import React from "react"
import { Link } from "gatsby"
import Container from "react-bootstrap/Container"
import Navbar from "react-bootstrap/Navbar"
import Nav from "react-bootstrap/Nav"
import "../css/header.scss"
import Logo from "../images/svg/logo.svg"
import AppStoreIcon from "../images/svg/ic_appstore.svg"

export const smoothScroll = {
  timer: null,

  stop: function() {
    clearTimeout(this.timer)
  },

  scrollTo: function(id, callback) {
    let settings = {
      duration: 1000,
      easing: {
        outQuint: function(x, t, b, c, d) {
          return c * ((t = t / d - 1) * t * t * t * t + 1) + b
        },
      },
    }
    const doc = document !== undefined ? document : null
    const thisWindow = window !== undefined ? window : null
    let percentage
    let startTime
    let node = doc.getElementById(id)
    if (!node) {
      return
    }
    let nodeTop = node.offsetTop
    let nodeHeight = node.offsetHeight
    let body = doc.body
    let html = doc.documentElement
    let height = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    )
    let windowHeight = thisWindow.innerHeight
    let offset = thisWindow.pageYOffset
    let delta = nodeTop - offset
    let bottomScrollableY = height - windowHeight
    let targetY =
      bottomScrollableY < delta
        ? bottomScrollableY - (height - nodeTop - nodeHeight + offset)
        : delta

    startTime = Date.now()
    percentage = 0

    if (this.timer) {
      clearInterval(this.timer)
    }

    function step() {
      let yScroll
      let elapsed = Date.now() - startTime

      if (elapsed > settings.duration) {
        clearTimeout(this.timer)
      }

      percentage = elapsed / settings.duration

      if (percentage > 1) {
        clearTimeout(this.timer)

        if (callback) {
          callback()
        }
      } else {
        yScroll = settings.easing.outQuint(
          0,
          elapsed,
          offset,
          targetY,
          settings.duration
        )
        thisWindow.scrollTo(0, yScroll)
        this.timer = setTimeout(step, 10)
      }
    }

    this.timer = setTimeout(step, 10)
  },
}

const Header = props => {
  return (
    <header
      {...props}
      className={"header " + (props.className ? props.className : "")}
    >
      <Container>
        <Navbar expand="md" className="px-0 py-3 justify-content-between">
          <Link to="/" className="navbar-brand py-0">
            <Logo width="125" />
          </Link>
          <h3 className="mb-0 d-none d-lg-block">
            Never fill out an I-9 or W-4 again
          </h3>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse
            id="responsive-navbar-nav"
            className="flex-grow-0 flex-shrink-0"
          >
            <Nav className="mr-auto align-items-md-center">
              <Nav.Item className="mb-md-0 mb-2 mr-md-3">
                <Link to="/faq" className="nav-link" activeClassName="active">
                  FAQs
                </Link>
              </Nav.Item>
              <Nav.Item className="mb-md-0 mb-2 mr-md-3">
                <Link to="/" state={{ contactJump: true }} className="nav-link">
                  Contact us
                </Link>
              </Nav.Item>
              <Nav.Item>
                <a
                  href="https://apps.apple.com/us/app/firstday/id1506188665"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="link-app-store d-inline-block d-md-flex align-items-center nav-link px-3"
                >
                  <AppStoreIcon
                    fill="currentColor"
                    width="20"
                    height="20"
                    className="mr-2"
                  />{" "}
                  Download App
                </a>
              </Nav.Item>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </Container>
    </header>
  )
}

export default Header
